export default __webpack_public_path__ + "78a71eebbb4cdba75159d264adf28eb5.svg";